import { WEDDING_TEXTS_GENERATED } from '../../action-types/ui/weddingTextGenerated';

export const setWeddingTextStatus = status => ({
  type: WEDDING_TEXTS_GENERATED,
  status,
});



// WEBPACK FOOTER //
// ./src/redux/actions/ui/weddingTextGenerated.js